import { TFunction } from "i18next";
import { type ColumnDef } from "~/components/table";
import { IProject } from "~/integrations/firebase/collections";
import { DataTableColumnHeader } from "~/components/ui/data-table-column-header";

import { type ProjectCellContext } from "./projects-table-body";
import { TableMenu } from "./table-menu";
import { UserProfile } from "~/components/user/user-profile";

export const columns: (t: TFunction) => ColumnDef<IProject>[] = (
  t: TFunction,
) => [
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader
        column={column}
        title={t("components:projectsTable.columns.name")}
      />
    ),
    cell: ({ row }) => <div className="w-[40%]">{row.getValue("name")}</div>,
  },
  {
    accessorKey: "createdAt",
    header: ({ column }) => (
      <DataTableColumnHeader
        column={column}
        title={t("components:projectsTable.columns.date")}
      />
    ),
    cell: ({ row }) => (
      <div className="flex space-x-2">
        {row.original?.createdAt?.toDateString() ?? "-"}
      </div>
    ),
  },
  {
    accessorKey: "books",
    header: ({ column }) => (
      <DataTableColumnHeader
        column={column}
        title={t("components:projectsTable.columns.books")}
      />
    ),
    cell: ({ row }) => {
      const books = (row.original.productIds as string[]) || [];
      return (
        <div className="flex items-center">
          <span>
            {`${books.length} ${books.length === 1 ? "book" : "books"}`}
          </span>
        </div>
      );
    },
  },
  {
    accessorKey: "userId",
    header: ({ column }) => (
      <DataTableColumnHeader
        column={column}
        title={t("components:projectsTable.columns.creator")}
      />
    ),
    cell: ({ row }) => {
      return <UserProfile userId={row.getValue("userId")} />;
    },

    filterFn: (row, id, value) => {
      return value.includes(row.getValue(id));
    },
  },
  {
    accessorKey: "menu",
    ignoreColumnClick: true,
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="" className="max-w-10" />
    ),
    cell: ({ row, isOwner }: ProjectCellContext) => (
      <div className="max-w-10">
        <TableMenu isOwner={isOwner} row={row} />
      </div>
    ),
  },
];
